// screen names
export const SCREEN_HOME = 'Home'
export const SCREEN_CLIENTS = 'Clients'
export const SCREEN_GROUP_EDIT = 'GroupEdit'
export const SCREEN_TASKS = 'Tasks'
export const SCREEN_CALL_CENTRE = 'Call Centre'
export const SCREEN_NOT_FOUND = '404'
export const SCREEN_TEST = 'Test'

// status
// Bulk actions in the tasks screen: how many action requests may be in flight at
// once. The backend caps out around one completed action per second regardless of
// how many are sent (tasks-service serves ~9 concurrent requests for the whole
// company), so a higher number does not finish the batch sooner, it only makes
// everyone else queue behind it.
export const MAX_CONCURRENT_BULK_ACTIONS = 5

// Addresses per group-endpoint request when refreshing rows after a bulk edit.
// They travel in the query string, so this keeps the URL well under the 8k
// request line limit of nginx.
export const BULK_REFRESH_CHUNK_SIZE = 50

// mirrored by the max_length on the batch endpoints in the tickets service
export const MAX_BATCH_SIZE = 100

export const CASE_CATEGORIES = ['Alarmbellen', 'KAM', 'Klantenservice', 'O&M', 'OPS']
export const MAINTENANCE_TYPES = [
  'Storing',
  'Service',
  'Lekkage',
  'Schadeherstel',
  'Herstel inspectie',
  'Installatiegarantie',
]
export const TICKET_PRIORITIES = ['Leak (6 hours)', 'Urgent', 'Normal']

export const STATUS_OK = 'OK'
export const STATUS_WARNING = 'warning'
export const STATUS_ERROR = 'error'
export const STATUS_SUCCESS = 'success'
export const STATUS_ALLOWED = 'allowed'
export const STATUS_UNAUTHORIZED = 'unauthorized'
export const STATUS_FORBIDDEN = 'forbidden'
export const STATUS_NOT_FOUND = 'not_found'

// permissions
export const PERMISSION_GROUPS_USER = 'groups_users'
export const PERMISSION_ADMINISTRATORS = 'administrators'

export const PERMISSION_ERP_USERS = 'erp_users'
export const PERMISSION_ERP_ADMINS = 'erp_admins'

export const PERMISSION_VIEW_SCREEN_CLIENTS = 'ERP_VIEW_SCREEN_CLIENTS'
export const PERMISSION_VIEW_SCREEN_TASKS = 'ERP_VIEW_SCREEN_TASKS'
export const PERMISSION_VIEW_SCREEN_CALL_CENTRE = 'ERP_VIEW_SCREEN_CALL_CENTRE'

export const PERMISSION_VIEW_PANE_CLIENTS = 'ERP_VIEW_PANE_CLIENTS'
export const PERMISSION_VIEW_PANE_DESIGN = 'ERP_VIEW_PANE_DESIGN'
export const PERMISSION_VIEW_PANE_INSTALLATION = 'ERP_VIEW_PANE_INSTALLATION'
export const PERMISSION_VIEW_PANE_INSPECTION = 'ERP_VIEW_PANE_INSPECTION'
export const PERMISSION_VIEW_PANE_SALES = 'ERP_VIEW_PANE_SALES'

export const PERMISSION_ACTION_COPY_ADDRESSES = 'ERP_ACTION_COPY_ADDRESSES'
export const PERMISSION_ACTION_EDIT_PRIVATE_GROUP = 'ERP_ACTION_EDIT_PRIVATE_GROUP'

// namespaces (events)
export const NAMESPACE_GLOBAL = 'global'

// event names
export const EVENT_RESIZE_START = 'resize-start'
export const EVENT_RESIZE_END = 'resize-end'
export const EVENT_SCROLL_START = 'scroll-start'
export const EVENT_SCROLL_END = 'scroll-end'

// task types
export const TASK_TYPE_DESIGN = 'design'
export const TASK_TYPE_SALES = 'sales'
export const TASK_TYPE_INSTALLATION = 'installation'
export const TASK_TYPE_INSPECTION = 'inspection'
export const TASK_TYPE_CLIENT = 'client'

export const monitoringOptions = [
  { value: 'no', label: 'Geen monitoring' },
  { value: 'monitoring_only', label: 'Alleen monitoring' },
  { value: 'monitoring_maintenance', label: 'Monitoring en onderhoud' },
]

export const entityOptions = [
  { value: 'Ecorus Home', label: 'Ecorus Home' },
  { value: 'Zoncorporatie', label: 'Zoncorporatie' },
]

export const productTypeOptions = [
  { value: 'pv', label: 'PV' },
  { value: 'pv_battery', label: 'PV + batterij' },
  { value: 'battery', label: 'Batterij' },
  { value: 'noly', label: 'Noly (alleen meter)' },
]

export const ticketStatuses = {
  created: 'Te plannen',
  planned: 'Gepland',
  ongoing: 'Bezig',
  finished: 'Afgerond',
  partner_approved: 'Goedgekeurd',
  rejected: 'Afgekeurd',
  approved: 'NORM GG',
  cancelled: 'Geannuleerd',
}

export const ticketStatusRingColorClass = {
  created: 'tw-ring-red-200',
  planned: 'tw-ring-gray-600',
  ongoing: 'tw-ring-yellow-400',
  finished: 'tw-ring-blue-300',
  partner_approved: 'tw-ring-[#8bd728]',
  rejected: 'tw-ring-red-400',
  approved: 'tw-ring-[#486f14]',
  cancelled: 'tw-ring-red-700',
}

export const ticketStatusBgColorClass = {
  created: 'tw-bg-red-200',
  planned: 'tw-bg-gray-600 tw-text-white',
  ongoing: 'tw-bg-yellow-400',
  finished: 'tw-bg-blue-300',
  partner_approved: 'tw-bg-[#8bd728]',
  rejected: 'tw-bg-red-400',
  approved: 'tw-bg-[#486f14] tw-text-white',
  cancelled: 'tw-bg-red-700 tw-text-white',
}
